import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import MembresPage from './pages/MembresPage';
import AgendaPage from './pages/AgendaPage';
import StatistiquesPage from './pages/StatistiquesPage';
import ProfilPage from './pages/ProfilPage';
import ContactsPage from './pages/ContactsPage';
import MerciPage from './pages/MerciPage';
import ChangePasswordPage from './pages/ChangePasswordPage';
import Layout from './components/Layout';
import './styles.css';

function PrivateRoute({ children, roles }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.some(r => user.roles?.includes(r))) return <Navigate to="/dashboard" replace />;
  return children;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/dashboard" replace /> : <LoginPage />} />
      <Route path="/changer-mot-de-passe" element={<ChangePasswordPage />} />
      <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="membres" element={<MembresPage />} />
        <Route path="agenda" element={<AgendaPage />} />
        <Route path="statistiques" element={<StatistiquesPage />} />
        <Route path="profil" element={<ProfilPage />} />
        <Route path="merci" element={<MerciPage />} />
        <Route path="contacts" element={<PrivateRoute roles={['animateur','franchise','super_admin']}><ContactsPage /></PrivateRoute>} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="top-right" toastOptions={{ duration: 4000, style: { fontSize: 14, borderRadius: 12, fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif' } }} />
      </BrowserRouter>
    </AuthProvider>
  );
}
